import NetworkManager from './NetworkManager';

export interface IUser {
  yumId: string;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  permissions: string[];
}

export interface IPermissionsResponse {
  status: boolean;
  data: IUser;
  accessToken: string;
}

export interface IStore {
  internalStoreNumber: string;
  champsNumber: string;
  storeName: string;
  brand: string;
  country: string;
  address?: {
    street?: string;
    city?: string;
  };
  timezone?: string;
  isTestStore: boolean;
  latitude?: number;
  longitude?: number;
  // Organizational hierarchy
  aisOrganizationId?: string;
  territoryId?: string;
  regionId?: string;
  regionName?: string;
  marketId?: string;
  areaId?: string;
  aisStoreId?: string;
  businessUnitId?: string;
}

export interface IStoresResponse {
  status: boolean;
  data: IStore[];
  count: number;
}

export async function redeemMappToken(mappToken: string): Promise<IPermissionsResponse> {
  return NetworkManager.post<IPermissionsResponse>('/permissions', { mappToken });
}

export async function getUserStores(): Promise<IStoresResponse> {
  return NetworkManager.get<IStoresResponse>('/stores?detailed=true');
}

// Export NetworkManager instance as 'api' for convenience
export const api = NetworkManager;

export { NetworkManager };
